import "./utils/extends-polyfill";//always first!
import '@kta20-webapp/utils/public-bridge';

import {IAppContext} from "@kta20-core/interfaces/i-app-context";
import {ModuleConfigService} from "@kta20-core/services/module-config-service";
import {
    BuildArgs,
    EnvProps,
    profileBuilder,
    AppContext
} from "@kta20-webapp/profiles/_build-args.generated";
import {MainConfig} from "@kta20-webapp/main-config";

//APP INITIALIZATION //
(async () => {
    const BuildProfile = profileBuilder(EnvProps);

    AppContext.get(<any>BuildArgs.platform, async(appContext:IAppContext)=>{
        const moduleNames = Object.keys(BuildProfile.Modules);
        for (let moduleName of moduleNames){
            const moduleConfig = BuildProfile.Config.find(mod => mod.name == moduleName) || null;
            await BuildProfile.Modules[moduleName].factory(
                appContext,
                moduleConfig
            );

            moduleConfig ? ModuleConfigService.get().setConfig(moduleConfig,moduleConfig.name) : null;
        }

        const mainConfig = (<any>BuildProfile.Config.find(it=>it.name===MainConfig.CLASS_NAME)) as MainConfig;
        if(mainConfig)
            await appContext.renderMain(
                mainConfig.entryPointName,
                mainConfig.options
            );
        else
            console.warn(MainConfig.WARNING);
    });
})();





